var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEssentialBcaas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.59 129.11H61l-16.75-29.06L61 71h33.59l16.78 29.06zM65 122.24h25.62l12.81-22.19-12.81-22.19H65l-12.81 22.19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139 154.74h-33.59l-16.78-29.07 16.78-29.06H139l16.78 29.06zm-29.59-6.88H135l12.81-22.19L135 103.49h-25.62l-12.81 22.18zm29.76-57.28H113L99.93 67.92 113 45.26h26.16l13.08 22.66zM117 83.7h18.2l9.11-15.78-9.11-15.78H117l-9.11 15.78z"
  })));
}
export default SvgEssentialBcaas;